import { Global } from '@emotion/core';
import { ThemeProvider } from '@material-ui/core';
import { RouteTypeEnum } from 'enums/routeType';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { Dispatch } from 'redux';
import { AppDispatch } from 'store';
import { refreshToken } from 'store/auth/auth.actions';
import history from 'utils/constants/history.const';
import { mainStyles } from '../main.style';
import { theme } from '../theme';
import CustomDialog from './Dialog/CustomDialog';
import Routes from './Routes/Routes';

interface IDispatchProps {
  refreshToken: () => AppDispatch;
}

type PropType = IDispatchProps;

class App extends React.Component<PropType> {
  componentDidMount(): void {
    const { refreshToken } = this.props;

    refreshToken();
    moment.updateLocale('en', { week: { dow: 1 } });
  }

  render(): JSX.Element {
    return (
      <Router history={history}>
        <ThemeProvider theme={theme}>
          <CustomDialog />
          <ToastContainer position="top-center" autoClose={5000} hideProgressBar closeOnClick pauseOnHover />
          <Global styles={mainStyles} />
          <Routes type={RouteTypeEnum.MAIN} />
        </ThemeProvider>
      </Router>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch<AppDispatch>): IDispatchProps => ({
  refreshToken: (): AppDispatch => dispatch(refreshToken()),
});

export default connect(null, mapDispatchToProps)(App);
